<template>
  <div class="ask-expert-ai">
    <div class="ask-expert-ai__title">
      <img class="ask-expert-ai__icon"
           src="/utd-ai/utd-ai-spark.svg"
           alt=""
           aria-hidden="true">
      <span>{{ $t("HEADER.ASK_EXPERT_AI") }}</span>
    </div>
    <div class="ask-expert-ai__buttons" role="group" aria-label="Ask Expert AI suggestions">
      <button v-for="(item, index) in suggestions"
              :key="item.uniqueId || `${item.label}-${index}`"
              type="button"
              class="ask-expert-ai__button"
              :title="item.label"
              @mousedown.prevent
              @keydown.enter.prevent="onSuggestionAction($event, item)"
              @click="onSuggestionAction($event, item)">
        {{ item.label }}
      </button>
    </div>
  </div>
</template>

<script>
import useExpertAiAction from '_acaSrc/composables/useExpertAiAction.composable';

export default {
    props: {
        suggestions: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    setup() {
        const { handleExpertAiAction } = useExpertAiAction();
        const onSuggestionAction = async(evt, item) => {
            const prompt = (item.label || '').trim();
            if (!prompt) {
                return;
            }
            await handleExpertAiAction({
                event: evt,
                prompt,
                queryParam: 'prompt',
                uiElementName: 'search-autocomplete-ask-expert-ai'
            });
        };
        return {
            onSuggestionAction
        };
    }
};
</script>

<style lang="less" scoped>
  @import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';
  @import (reference) '~_acaAssets/global/global.less';

  .ask-expert-ai {
    .ds1-ph-2();
    .ds1-pv-2();
    background-color: @WKCE-CREAM-TINT2;
  }

  .ask-expert-ai__title {
    .ds1-utd-size-3();
    .ds1-utd-weight-normal();
    .ds1-mb-2();
    /* stylelint-disable-next-line color-no-hex */
    color: #654D48;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .ask-expert-ai__icon {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  .ask-expert-ai__buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    overflow: hidden;
    max-height: 72px;
    padding: 2px;
  }

  .ask-expert-ai__button {
    .ds1-utd-size-3();
    .ds1-utd-weight-600();
    height: 32px;
    max-width: 100%;
    border-radius: 16px;
    /* stylelint-disable-next-line declaration-property-value-no-unknown */
    border: 1px solid @WKCE-CREAM-TINT1;
    background-color: @WKCE-WHITE;
    color: @DS1-UTD-TOPIC-TEXT-COLOR;
    padding: 0 12px;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    outline: none;
    transition: background-color .12s ease, border-color .12s ease, box-shadow .12s ease;

    &:hover {
      background-color: @WKCE-CREAM-TINT1;
      border-color: @WKCE-CREAM-TINT1;
    }

    &:focus-visible {
      background-color: @WKCE-WHITE;
      border-color: @WKCE-BLACK;
      /* stylelint-disable-next-line declaration-property-value-no-unknown */
      box-shadow: 0 0 0 2px @WKCE-BLACK;
    }

    &:active {
      background-color: @WKCE-CREAM;
      border-color: @WKCE-CREAM;
      box-shadow: none;
    }
  }
</style>
